// sagas.js
import { call, put, takeLatest } from "redux-saga/effects";
import {
  returnParsedResumeSuccess,
  returnParsedResumeFailure,
} from "./actions";
import { RETURN_PARSED_RESUME_REQUEST } from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";

function* handleParseResume(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("return_parse_resume", action.payload)
    );
    console.log(response);
    if (response.data.status) {
      yield put(returnParsedResumeSuccess(response.data));
    } else {
      yield put(returnParsedResumeFailure(response.data));
    }
  } catch (error) {
    yield put(
      returnParsedResumeFailure({ status: false, message: error.message })
    );
  }
}

function* returnParseResumeSaga() {
  yield takeLatest(RETURN_PARSED_RESUME_REQUEST, handleParseResume);
}

export default returnParseResumeSaga;
